import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    csoiFilteredOption: ""
};

const hedgeFunds = createSlice({
    name: 'HEDGEFUNDSLICE',
    initialState,
    reducers: {
        setCsoiFilteredCaption(state, action) {
            state.csoiFilteredOption = action.payload;
        }
    }
});

export const {setCsoiFilteredCaption} = hedgeFunds.actions

export default hedgeFunds;